import {connect} from 'react-redux';
import './DisclaimerText.scss';
import DisclaimerText from './DisclaimerText';

const mapStateToProps = (state, ownProps) => {

  return {
    ...ownProps
  };
};

const mapDispatchToProps = (_) => {
  return {
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
  };
};

const DisclaimerTextContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(DisclaimerText);

export { DisclaimerTextContainer, DisclaimerText };
export default DisclaimerTextContainer;